<template>
  <v-container>
    <v-card class="my-5">
      <v-card-title class="overline">
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        Notice Board
      </v-card-title>
      <v-divider />

      <info-section />
    </v-card>
  </v-container>
</template>

<script>
import InfoSection from "../../../components/InfoSection";
export default {
  name: "notificationsComponent",
  components: { InfoSection },
};
</script>

<style scoped></style>
